import { FC, useMemo } from "react";
import { MDBContainer } from "mdb-react-ui-kit";
import SectionCarouselLayout from "../common/SectionCarouselLayout";
import {
    TBreackpointsCarousel,
    SectionsTitleText,
} from "../../models/common/common";
import WhyPlayItalyCard from "./WhyPlayItalyCard";
import styles from "../../styles/detail/WhyPlayItaly.module.scss";
import colors from "../../styles/colors.module.scss";

interface WhyPlayItalyCardData {
    id: string;
    image: string;
    title: string;
    description: string;
}

const WhyPlayItaly: FC = () => {
    const cardsData: WhyPlayItalyCardData[] = [
        {
            id: "private-transfer",
            image: "/images/tours/private-transfer.png",
            title: "Private Transfer",
            description:
                "From arrival to departure, every transfer is seamlessly arranged for you.",
        },
        {
            id: "dedicated-concierge",
            image: "/images/tours/Dedicated-concierge.png",
            title: "Dedicated Concierge",
            description:
                "Your personal concierge ensures every detail of your journey runs effortlessly, from planning to return.",
        },
        {
            id: "enriching-experiences",
            image: "/images/tours/Enriching-Experiences.png",
            title: "Enriching Experiences",
            description:
                "Meaningful journeys crafted around your passions and refined tastes.",
        },
        {
            id: "priority-access",
            image: "/images/tours/Priority-access.jpg",
            title: "Priority Access",
            description:
                "Save time with fast-track access to must-see museums and other major attractions.",
        },
        {
            id: "expert-tour-guides",
            image: "/images/tours/Expert-tour-guides.png",
            title: "Expert Tour Guides",
            description:
                "Explore Italy with expert local guides who live and breathe the local culture.",
        },
    ];

    const sectionTitle: SectionsTitleText[] = [
        {
            text: "What Makes Every ",
            color: colors.textBlack,
            fontWeight: "fw-bold",
            newLine: true,
        },
        {
            text: "Play Italy ",
            color: colors.textBlack,
            fontWeight: "fw-bold",
            newLine: false,
        },
        {
            text: "Journey Exclusive",
            color: colors.textPrimary,
            fontWeight: "fw-bold",
            newLine: false,
        },
    ];

    const breakpointsCarousel: TBreackpointsCarousel = {
        0: {
            slidesPerView: 1,
            spaceBetween: 16,
            slidesOffsetBefore: 40,
            slidesOffsetAfter: 20,
        },
        768: {
            slidesPerView: 3,
            spaceBetween: 16,
        },
        1200: {
            slidesPerView: 4,
            spaceBetween: 16,
        },
    };

    const visibleCards = useMemo(() => {
        return cardsData.map(card => (
            <WhyPlayItalyCard key={card.id} content={card} />
        ));
    }, []);

    return (
        <MDBContainer fluid className={styles.container}>
            <SectionCarouselLayout
                visibleSlides={4}
                sectionTitle={sectionTitle}
                sectionSubTitle={[]}
                isCarouselContained={false}
                breakpointsCarousel={breakpointsCarousel}
                showNavigation
                classNameSlide={styles.cardSlide}
                classNameCarousel={styles.carouselContainer}
            >
                {visibleCards}
            </SectionCarouselLayout>
        </MDBContainer>
    );
};

export default WhyPlayItaly;
